import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { FacilityOrderPayPackagesFilterName } from './filterUtils';

const getSelectedValues = (filters: any, selectedChipFilters: any, key: string) => {
  if (selectedChipFilters && selectedChipFilters[key]) {
    return selectedChipFilters[key];
  }
  return filters?.[key];
};

export const filterFacilityOrderPayPackagesRows = (rows: any[], filterObject: any) => {
  if (!Array.isArray(rows) || !filterObject?.filters) return rows || [];

  const filters = filterObject.filters;
  const selected = filterObject.selectedChipFilters;

  const orderIds = getSelectedValues(filters, selected, FacilityOrderPayPackagesFilterName.orderId) || [];
  const selectedOrderIds = Array.isArray(orderIds)
    ? orderIds.map(x => x?.value ?? x).filter(v => !isNullOrUndefined(v) && `${v}`.length > 0).map(String)
    : [];

  const weeklyGrossMargins = getSelectedValues(
    filters,
    selected,
    FacilityOrderPayPackagesFilterName.weeklyGrossMargin,
  ) || [];
  const selectedMargins = Array.isArray(weeklyGrossMargins)
    ? weeklyGrossMargins.map(x => x?.value ?? x).filter(v => typeof v === 'string' && v.length > 0)
    : [];

  const shifts = getSelectedValues(filters, selected, FacilityOrderPayPackagesFilterName.shift) || [];
  const selectedShifts = Array.isArray(shifts)
    ? shifts.map(x => x?.value ?? x).filter(v => typeof v === 'string' && v.trim().length > 0)
    : [];

  const postingStatuses = getSelectedValues(filters, selected, FacilityOrderPayPackagesFilterName.postingStatus) || [];
  const selectedPostingStatuses = Array.isArray(postingStatuses)
    ? postingStatuses.map(x => x?.value ?? x).filter(v => typeof v === 'string' && v.trim().length > 0)
    : [];

  return rows.filter(row => {
    if (selectedOrderIds.length > 0) {
      const rowOrderId = row?.orderId ?? row?.orderID;
      const rowOrderIdStr = !isNullOrUndefined(rowOrderId) ? String(rowOrderId) : null;
      if (!rowOrderIdStr || !selectedOrderIds.includes(rowOrderIdStr)) return false;
    }

    if (selectedMargins.length > 0) {
      const rowMargin = row?.currentTargetMargin;
      const rowMarginStr =
        rowMargin != null && !Number.isNaN(Number(rowMargin))
          ? `${Number(rowMargin).toFixed(2)}%`
          : null;
      if (!rowMarginStr || !selectedMargins.includes(rowMarginStr)) return false;
    }

    if (selectedShifts.length > 0) {
      const rowShift = `${row?.shift ?? ''}`.trim();
      if (!rowShift || !selectedShifts.includes(rowShift)) return false;
    }

    if (selectedPostingStatuses.length > 0) {
      const rowStatus = `${row?.publishingStatus ?? ''}`.trim();
      if (!rowStatus || !selectedPostingStatuses.includes(rowStatus)) return false;
    }

    return true;
  });
};
